import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import GoogleMapArea from "../../components/GoogleMapArea";
import GoogleMap from "../../components/GoogleMap";
import Loader from '../../components/Loader';
import TimingModal from '../../components/TimingModal';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import LookupService from '../../services/LookupService';

const BranchForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState("info");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isLoader, setIsLoader] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [timings, setTimings] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    name_ar: '',
    email: '',
    phone: '',
    password: '',
    pos_id: '',
    is_delivery: true,
    is_pickup: true,
    payment_methods: [],
  });
 
  const [area_coordinates, setAreaCoordinates] = useState();

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getSingleData();
  };

  // Load branch data if editing an existing branch
  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);

  const getSingleData = async () => {
    try {
      setPageLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `branches/${id}`,
      });

      const data = response.data;
      if (data.status) {
        const branch = data.data.branch;
        setTimings(data.data.timings);
        setFormData({
          name: branch.name,
          name_ar: branch.name_ar,
          email: branch.email,
          phone: branch.phone,
          delivery_charges: branch.delivery_charges,
          delivery_radius: branch.delivery_radius,
          delivery_time: branch.delivery_time,
          preparing_time: branch.preparing_time,
          pos_id: branch.pos_id,
          is_delivery: branch.is_delivery,
          is_pickup: branch.is_pickup,
          lat: branch.lat,
          lng: branch.lng,
          location: branch.location,
          payment_methods: (branch.payment_methods)?branch.payment_methods.split(','):[],
        });
        setAreaCoordinates(branch.area_coordinates);

      } else {
        toast.error(data.message);
      }
      setPageLoader(false);
    } catch (error) {
      console.log(error);
      setPageLoader(false);
    }
  };


  const areaChanged = (newLocation) => {
    console.log(newLocation);
    setAreaCoordinates(newLocation);
  };


  const handleChange = (index, field, value) => {
    const updatedTimings = [...timings];
    updatedTimings[index][field] = field === "is_off" ? !updatedTimings[index][field] : value;
    setTimings(updatedTimings);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoader(true);

    try {
      const form = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        form.append(key, value);
      });
      // form.append('lat', location.lat);
      // form.append('lng', location.lng);
      // form.append('location', location.text);
      form.append('area_coordinates', JSON.stringify(area_coordinates));

      const response = await ApiService.request({
        method: 'POST',
        url: `branches/createOrUpdate/${id || ''}`,
        data: form,
      });

      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        LookupService.clear('branches-list');
        if (id) {
          navigate('/branches');
        }else{
          navigate('/branches/create/'+data.data?._id+'?tab=timings');
        }
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };

  const updateTiming = async (event) => {
    event.preventDefault();
    setIsLoader(true);

    try {
      
      const response = await ApiService.request({
        method: 'POST',
        url: `branches/updateTimings/${id || ''}`,
        data: {'timings':timings},
      });

      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        navigate('/branches');
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      {/* Toolbar */}
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit' : 'Add New'} Branch
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a href="/dashboard" className="text-muted text-hover-primary">Dashboard</a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <a href="/branches" className="text-muted text-hover-primary">Branches</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Content */}
      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className={`nav-link fs-lg-5 ${tab === "info" ? "active" : ""}`}
                  onClick={() => setTab("info")}
                  id="nav-profile-tab"
                  type="button"
                >
                  <i className="bi bi-envelope-fill"></i> Branch Info
                </button>
                <button
                  className={`nav-link fs-lg-5 ${tab === "timings" ? "active" : ""}`}
                  onClick={() => setTab("timings")}
                  id="nav-contact-tab"
                  type="button"
                >
                  <i className="bi bi-clock-fill"></i> Branch  Timings
                </button>
              </div>
            </nav>
            <div className="card-body pt-0">
              {/* Info Form */}
              {tab === "info" && (
                <form encType="multipart/form-data" method="POST" className="form fv-plugins-bootstrap5 fv-plugins-framework" onSubmit={handleSubmit}>
                  <div className="row g-9 my-3">
                    {/* Branch Name */}
                    <div className="col-md-6 fv-row">
                      <label className="required fs-6 fw-semibold mb-2">Branch Name</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Branch Name"
                        required
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      />
                    </div>
                    {/* Branch Name Arabic */}
                    <div className="col-md-6 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Branch Name Arabic</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Branch Name Arabic"
                        
                        value={formData.name_ar}
                        onChange={(e) => setFormData({ ...formData, name_ar: e.target.value })}
                      />
                    </div>

                    {/* Email */}
                    <div className="col-md-6 fv-row">
                      <label className="required fs-6 fw-semibold mb-2">Email</label>
                      <input
                        type="email"
                        className="form-control form-control-solid"
                        placeholder="Enter Branch Email"
                        required
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      />
                    </div>
                    {/* Password */}
                    <div className="col-md-6 fv-row">
                      <label className="fs-6 fw-semibold mb-2">Password</label>
                      {id && <small className="text-info mx-3">(Leave empty if don't want to update password)</small>}
                      <input
                        type="password"
                        className="form-control form-control-solid"
                        placeholder="Branch Password"
                        value={formData.password}
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                      />
                    </div>
                    {/* Phone */}
                    <div className="col-md-6 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Phone</label>
                      <input
                        type="number"
                        className="form-control form-control-solid"
                        placeholder="971xxxxxxx"
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      />
                    </div>
                    <div className="col-md-6 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">POS ID</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="POS ID"
                        value={formData.pos_id}
                        onChange={(e) => setFormData({ ...formData, pos_id: e.target.value })}
                      />
                    </div>
                    {/* <div className="col-md-6 fv-row">
                      <label className="required fs-6 fw-semibold mb-2">Delivery Radius (Km)</label>
                      <input
                        type="number"
                        className="form-control form-control-solid"
                        placeholder="Delivery radius"
                        value={formData.delivery_radius}
                        onChange={(e) => setFormData({ ...formData, delivery_radius: e.target.value })}
                      />
                    </div> */}
                    <div className="col-md-6 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Delivery Charges (AED)</label>
                      <input
                        type="number"
                        className="form-control form-control-solid"
                        placeholder="Delivery charges"
                        value={formData.delivery_charges}
                        onChange={(e) => setFormData({ ...formData, delivery_charges: e.target.value })}
                      />
                    </div>
                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Preparing Time (mins)</label>
                      <input
                        type="number"
                        className="form-control form-control-solid"
                        placeholder="Preparing time"
                        value={formData.preparing_time}
                        onChange={(e) => setFormData({ ...formData, preparing_time: e.target.value })}
                      />
                    </div>
                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Delivery Time (mins)</label>
                      <input
                        type="number"
                        className="form-control form-control-solid"
                        placeholder="Delivery time"
                        value={formData.delivery_time}
                        onChange={(e) => setFormData({ ...formData, delivery_time: e.target.value })}
                      />
                    </div>
                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Enable Delivery</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox"  
                          checked={formData.is_delivery === true} onChange={(e) => setFormData({ ...formData, is_delivery: e.target.checked })}
                            name="is_delivery" id="flexSwitchCheckChecked" />
                      </div>
                    </div>
                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Enable Pickup</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" 
                          checked={formData.is_pickup === true} onChange={(e) => setFormData({ ...formData, is_pickup: e.target.checked })}
                           name="is_pickup" id="flexSwitchCheckChecked" />
                      </div>
                     
                    </div>

                    <div className="col-md-12 fv-row">
                      <h6>Payment Methods</h6>
                      <div className="row">
                        <div className="col-2">
                            <label className=" fs-6 fw-semibold mb-2">Online (Card)</label>
                            <div className="form-check form-switch mt-2">
                                <input className="form-check-input" type="checkbox"  
                                  checked={formData.payment_methods.includes('Card')} 
                                  onChange={(e) => {
                                    const { checked } = e.target;
                                    setFormData(prev => ({
                                      ...prev,
                                      payment_methods: checked
                                        ? [...prev.payment_methods, 'Card'] // Add if checked
                                        : prev.payment_methods.filter(method => method !== 'Card') // Remove if unchecked
                                    }));
                                  }}
                                  name="payment_methods"
                                  id="CardCheckChecked" />
                            </div>
                        </div>
                        <div className="col-2">
                          <label className=" fs-6 fw-semibold mb-2">Apple Pay</label>
                          <div className="form-check form-switch mt-2">
                              <input className="form-check-input" type="checkbox"  
                                checked={formData.payment_methods.includes('Apple Pay')} 
                                onChange={(e) => {
                                  const { checked } = e.target;
                                  setFormData(prev => ({
                                    ...prev,
                                    payment_methods: checked
                                      ? [...prev.payment_methods, 'Apple Pay'] // Add if checked
                                      : prev.payment_methods.filter(method => method !== 'Apple Pay') // Remove if unchecked
                                  }));
                                }}
                                name="payment_methods"
                                id="CardCheckChecked" />
                          </div>
                        </div>
                        <div className="col-2">
                          <label className=" fs-6 fw-semibold mb-2">Card on Delivery </label>
                          <div className="form-check form-switch mt-2">
                              <input className="form-check-input" type="checkbox"  
                                checked={formData.payment_methods.includes('Card on Delivery')} 
                                onChange={(e) => {
                                  const { checked } = e.target;
                                  setFormData(prev => ({
                                    ...prev,
                                    payment_methods: checked
                                      ? [...prev.payment_methods, 'Card on Delivery'] // Add if checked
                                      : prev.payment_methods.filter(method => method !== 'Card on Delivery') // Remove if unchecked
                                  }));
                                }}
                                name="payment_methods"
                                id="CardCheckChecked" />
                          </div>
                        </div>
                        <div className="col-3">
                          <label className=" fs-6 fw-semibold mb-2">Cash on Delivery (COD)</label>
                          <div className="form-check form-switch mt-2">
                              <input className="form-check-input" type="checkbox"  
                                checked={formData.payment_methods.includes('COD')} 
                                onChange={(e) => {
                                  const { checked } = e.target;
                                  setFormData(prev => ({
                                    ...prev,
                                    payment_methods: checked
                                      ? [...prev.payment_methods, 'COD'] // Add if checked
                                      : prev.payment_methods.filter(method => method !== 'COD') // Remove if unchecked
                                  }));
                                }}
                                name="payment_methods"
                                id="CardCheckChecked" />
                          </div>
                        </div>
                        <div className="col-3">
                          <label className=" fs-6 fw-semibold mb-2">Cash on Pickup (COP)</label>
                          <div className="form-check form-switch mt-2">
                              <input className="form-check-input" type="checkbox"  
                                checked={formData.payment_methods.includes('COP')} 
                                onChange={(e) => {
                                  const { checked } = e.target;
                                  setFormData(prev => ({
                                    ...prev,
                                    payment_methods: checked
                                      ? [...prev.payment_methods, 'COP'] // Add if checked
                                      : prev.payment_methods.filter(method => method !== 'COP') // Remove if unchecked
                                  }));
                                }}
                                name="payment_methods"
                                id="CardCheckChecked" />
                          </div>
                        </div>

                      </div>
                      
                      
                      
                    </div>
                  

                    {/* Google Map */}
                    <div className="col-md-6">
                      <label className="required fs-5 fw-semibold mb-2">Address</label>
                      <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Address"
                      value={formData.location}
                      onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                    />
                    </div>
                    <div className="col-md-3">
                      <label className="required fs-5 fw-semibold mb-2">Latitude</label>
                      <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Latitude"
                      value={formData.lat}
                      onChange={(e) => setFormData({ ...formData, lat: e.target.value })}
                    />
                    </div>
                    <div className="col-md-3">
                      <label className="required fs-5 fw-semibold mb-2">Longitude</label>
                      <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Longitude"
                      value={formData.lng}
                      onChange={(e) => setFormData({ ...formData, lng: e.target.value })}
                    />
                    </div>

                    {/* Google Map  Area Selection */}
                    {!pageLoader && 
                      <div className="col-md-12">
                        <label className="required fs-5 fw-semibold mb-2">Mark Area on Map</label>
                        <GoogleMapArea onAreaSelected={areaChanged} areaOld={area_coordinates} />
                      </div>
                    }
                  </div>

                  {/* Actions */}
                  <div className="text-center">
                    <button type="button" className="btn btn-light me-3" onClick={() => navigate(-1)}>
                      Back
                    </button>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      <span className="indicator-label" hidden={isLoader}>Submit</span>
                      {isLoader && <Loader size={20} text="Submitting" />}
                    </button>
                  </div>
                </form>
              )}

              {tab === "timings" && (
                <form encType="multipart/form-data" method="POST" className="form fv-plugins-bootstrap5 fv-plugins-framework" onSubmit={updateTiming}>
                  <button type='button' onClick={()=>setIsModalOpen(true)} className='btn btn-base btn-sm float-end my-3'>Apply Same Timing</button> <br />
                  <div className="table-responsive">
                    <table className="table table-striped fs-6">
                      <thead>
                        <tr className="fw-bold">
                          <th className="p-3">DAY</th>
                          <th className="p-3">Open</th>
                          <th className="p-3">Close</th>
                          <th className="p-3">IS OFF</th>
                        </tr>
                      </thead>
                        <tbody>
                            {timings.map((timing, index) => (
                              <tr key={timing.day} className="border">
                                <td className="p-3 fw-bold">
                                  {timing.day}
                                  <input type="hidden" name="days[]" value={timing.day} />
                                </td>
                                <td>
                                  <input
                                    type="time"
                                    name={`open[${timing.day}]`}
                                    className="form-control border"
                                    value={timing.open}
                                    onChange={(e) => handleChange(index, "open", e.target.value)}
                                    disabled={timing.is_off}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="time"
                                    name={`close[${timing.day}]`}
                                    className="form-control border"
                                    value={timing.close}
                                    onChange={(e) => handleChange(index, "close", e.target.value)}
                                    disabled={timing.is_off}
                                  />
                                </td>
                                <td>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name={`is_off[${timing.day}]`}
                                      checked={timing.is_off}
                                      onChange={() => handleChange(index, "is_off")}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                    </table>
                  </div>

                  {/* Actions */}
                    <div className="text-center">
                      <button type="button" className="btn btn-light me-3" onClick={() => navigate('/branches')}>
                        Back
                      </button>
                      <button type="submit" className="btn btn-base" disabled={isLoader || !id}>
                        <span className="indicator-label" hidden={isLoader}>Submit</span>
                        {isLoader && <Loader size={20} text="Submitting" />}
                      </button>
                    </div>
                </form>
              )}

                {isModalOpen && <TimingModal branchId={id}  closeModal={handleCloseModal} />}

            </div>
          </div>
          
        </div>
      </div>
      
    </div>
  );
};

export default BranchForm;
